import { useCallback } from "react";

export function useButton(cardHtml: HTMLElement) {
  const getButtonByLabel = useCallback(
    (label: string) => {
      const buttons = cardHtml.getElementsByTagName("button");
      return Array.from(buttons).find(button => button.getAttribute("aria-label") === label);
    },
    [cardHtml]
  );

  const removeClickHandler = useCallback(
    (buttonLabel: string) => {
      const button = getButtonByLabel(buttonLabel);

      if (!button) return;

      // disable add choice button
      button.onclick = e => {
        e.preventDefault();
      };
    },
    [getButtonByLabel]
  );

  const attachClickHandler = useCallback(
    (buttonLabel: string, handler: Function) => {
      const button = getButtonByLabel(buttonLabel);

      if (!button) {
        return;
      }

      button.onclick = e => {
        e.preventDefault();
        handler();
      };
    },
    [getButtonByLabel]
  );

  // NOTE: Update these labels whenever the text of these buttons is changed in cards.
  const buttonLabels = {
    SubmitVoteButtonLabel: "Submit vote",
    SubmitResponseButtonLabel: "Submit response",
    AddChoiceButtonLabel: "+ Add choice",
    AddCommentButtonLabel: "Add comment",
    StartQuizButtonLabel: "Start quiz",
    ViewResultsButtonLabel: "View results",
    ViewAllResultsButtonLabel: "View all results",
    NextButtonLabel: "Next ❯",
    PreviousButtonLabel: "❮ Previous",
  };

  return { getButtonByLabel, removeClickHandler, attachClickHandler, buttonLabels };
}
